module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerpage', {
    attrs: {
      "status": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.show_pic)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "box_top_img",
    attrs: {
      "src": require("../../assets/images/qie/10.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1 adaptation"
  }, [_c('div', {
    staticClass: "box1_cent",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('img', {
    staticClass: "box1_cent_left",
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.image_one)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_cent_right"
  }, [_vm._v("\n                " + _vm._s(_vm.detail.title_one) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "box1_cent",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticClass: "box1_cent_right"
  }, [_vm._v("\n                " + _vm._s(_vm.detail.title_two) + "\n            ")]), _vm._v(" "), _c('img', {
    staticClass: "box1_cent_left",
    staticStyle: {
      "right": "0",
      "left": "auto"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.image_two)
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-163b2904"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/brief/index.vue
// module id = 881
// module chunks = 1